var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.980591 2.49878C0.770591 2.49878 0.560591 2.57878 0.39059 2.70878C-0.0494095 3.04878 -0.129409 3.67878 0.210591 4.10878V4.11878L5.52059 10.9188V16.9088L7.81059 19.2088C8.20059 19.5988 8.84059 19.5988 9.23059 19.2088C9.62059 18.8188 9.62059 18.1788 9.23059 17.7888L7.52059 16.0888V10.2288L1.79059 2.88878C1.69486 2.76564 1.57191 2.66635 1.43138 2.59869C1.29084 2.53103 1.13655 2.49683 0.980591 2.49878ZM13.5206 9.49878V17.3788C13.5606 17.6788 13.4606 17.9988 13.2306 18.2088C13.1381 18.3015 13.0282 18.375 12.9072 18.4252C12.7862 18.4754 12.6566 18.5012 12.5256 18.5012C12.3946 18.5012 12.2649 18.4754 12.144 18.4252C12.023 18.375 11.9131 18.3015 11.8206 18.2088L9.81059 16.1988C9.70152 16.0922 9.6186 15.9618 9.56829 15.8178C9.51798 15.6738 9.50166 15.5201 9.52059 15.3688V9.49878H9.49059L3.73059 2.11878C3.5682 1.91031 3.49492 1.64604 3.52678 1.38371C3.55863 1.12138 3.69303 0.882326 3.90059 0.718779C4.09059 0.578779 4.30059 0.498779 4.52059 0.498779H18.5206C18.7406 0.498779 18.9506 0.578779 19.1406 0.718779C19.3482 0.882326 19.4825 1.12138 19.5144 1.38371C19.5463 1.64604 19.473 1.91031 19.3106 2.11878L13.5506 9.49878H13.5206Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFilter);
export default __webpack_public_path__ + "static/media/whiteFilter.5128efd065c5aa4defe22f55cc98d56c.svg";
export { ForwardRef as ReactComponent };